<template>
    <div class="pt-2">
      <v-row class="px-8"> 
        <div style="margin-top:12px;">
          <v-btn
            @click="geolocation"
            large
            class="px-0"
            color="#009640"
            style="min-width: min-content !important;"
          >
            <v-img :width="55" :height="45" contain src="../assets/icons/location.svg"></v-img>
          </v-btn>
        </div>
        
        <div class="ml-3" style="font-size: 18px; color: #79828c; font-weight: 500; margin-top: 20px">
          Activar ubicación
        </div>

        <div class="hide" style="margin-top: 14px">
          <gmap-autocomplete
              class="form-control py-0 ml-8"
              
              placeholder="Sitios o dirección, ciudad, código postal"
              :options="autocompleteOptions"
              style="font-size: 16px; color: #8f95a2 !important; 
                min-width: 250px; min-height: 35px; padding-left: 8px; 
                border:none;
                border-bottom: 1px solid #8f95a2;
                outline: none;"
              @place_changed="setPlace">
          </gmap-autocomplete>
        </div>
            
        <v-flex xs12 sm1 d-flex class="pb-0 ml-4">
          <v-select
            :items="items"
            item-text="text"
            item-value="value"
            label="Radio"
            v-model="getRadius"
            single-line
            style="font-size: 19px !importat;"
            @change="changeRadius"
          ></v-select>
        </v-flex>
        
      </v-row>
      
    </div>
</template>

<script>
import axios from "axios";
import citiesJson from '../assets/json/_cities';
import ApiService from "../service/ApiService";
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: "AppBar",
    data () {
      return {
        items: [
          {text: '0.5 Km', value: 500},
          {text: '1 Km', value: 1000},
          {text: '1.5 Km', value: 1500},
        ],
        autocompleteOptions: {
          fields: ['geometry', 'formatted_address', 'address_components'],
          componentRestrictions: {
            country: [
              'co',
            ],
          },
        },
        apiService: null,
        placeSelect: null
      }
    },
    created() {
      this.apiService = new ApiService();
    },
    computed: {
      ...mapGetters(['getRadius', 'getLocationUser']),
    },
    methods: {
      ...mapMutations(['cleanMarkers']),
      ...mapActions(['addCenter', 'addRadius', 'addLocationUser', 'addMarker', 'addPoints', 'addDialog']),
      setPlace(place) {
        
        if(place.formatted_address){
          this.placeSelect = place.geometry.location;
          let listPlaces = place.formatted_address.split(', ');
          if (listPlaces.length > 3){
            this.getLatLonSoap(listPlaces, listPlaces[0]);
          } else {
            this.changePlace(this.placeSelect.lat(), this.placeSelect.lng());
          }
        }
      },
      changePlace(lat, lon) {
        const positionUser = { lat: lat, lng: lon};
        const radius = this.getRadius != 0 ? this.getRadius : 500; 
        this.addCenter(positionUser);
        this.addLocationUser(positionUser);
        this.addRadius(radius);
        this.getListPointsAttention(positionUser.lat, positionUser.lng, radius)
      },
      changeRadius(rad) {
        if(this.getLocationUser.lat !== 0){
          this.addRadius(rad);
          this.getListPointsAttention(this.getLocationUser.lat, this.getLocationUser.lng, rad)
        }
      },
      async geolocation() {
        navigator.geolocation.getCurrentPosition(position => {
          var center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.addCenter(center);
          this.addLocationUser(center);
          this.addRadius(500);
          this.getListPointsAttention(position.coords.latitude, position.coords.longitude, this.getRadius)
        },
        () => {
          this.addDialog('Lo sentimos ha ocurrido un problema al obtener tu ubicación');
        });
      },
      async getListPointsAttention(lat, lon, radio) {

        const res = await this.apiService.getPointsAttention(lat, lon, radio);
        if(res.status == 200) {
          //this.$refs.googleMap.clearMarkers();
          this.cleanMarkers();

          const listpoints = res.data.Results
          for(let i = 0; i < listpoints.length; i++){
            listpoints[i].select = false
            const lat = listpoints[i].LATITUDE
            const lon = listpoints[i].LONGITUDE
            const obj = {
              lat: lat,
              lng: lon
            };
            await this.addMarker(obj)
          }
          this.addPoints(listpoints);
        } else if(res.status == 400) {        
          this.addPoints([]);
          this.addDialog("Lo sentimos, no se ha encontrado información para este lugar.");
        } else {
          this.addPoints([]);
          this.addDialog("Lo sentimos, hubo un problema con el servicio");
        }
      },
      getLatLonSoap(city, address) {
        
        var idCity = 0;
        //Se normaliza el nombre para que no tenfa caracteres especiales en la comparación
        var citySelect = city[1].normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        var departSelect = city[2].normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        if(departSelect.toUpperCase() == 'BOGOTA'){
          departSelect = 'cundinamarca';
          citySelect = 'bogota';
        }

        citiesJson.cities.forEach((item) => {
          const cityName = item.nombre_ciudad.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          const departName = item.NOMBRE_DEPARTAMENTO.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          if(cityName.toUpperCase() == citySelect.toUpperCase() && departName.toUpperCase() == departSelect.toUpperCase()){
            idCity = item.id_ciudad;
            return
          }
        });
        
        //Inicio Petición SOAP - Geolocalizador
        let xmls =
          `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">\
            <soapenv:Header/>\
            <soapenv:Body>\
                <tem:Georreferenciar>\
                  <tem:idPais>1</tem:idPais>\
                  <tem:idCiudad>${idCity}</tem:idCiudad>\
                  <tem:idProducto>1</tem:idProducto>\
                  <tem:idTiempo>1</tem:idTiempo>\
                  <tem:idTipoLogistica>1</tem:idTipoLogistica>\
                  <!--Optional:-->\
                  <tem:idCapa></tem:idCapa>\
                  <!--Optional:-->\
                  <tem:direccion>${address}</tem:direccion>\
                </tem:Georreferenciar>\
            </soapenv:Body>\
          </soapenv:Envelope>`;

        axios.post('http://web.servientrega.com/WSGeoreferenciador/wsGeocoder.asmx',
            xmls,
            {
              headers: {'Content-Type': 'text/xml'}
            })
            .then(res=>{
              if(res.status == 200){
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(res.data,"text/xml")
                var result = xmlDoc.children[0].children[0].children[0].children[0].children;
                
                var lat = this.placeSelect.lat();
                var lon = this.placeSelect.lng();

                if( result.length > 4){
                  let latXml = result[5].innerHTML;
                  let lonXml = result[6].innerHTML;
                  
                  if (latXml != 0 && lonXml != 0 ){
                    lat = latXml/100000000;
                    lon = lonXml/100000000;
                  } 
                }
                this.changePlace(lat, lon);
              } else {
                this.changePlace(this.placeSelect.lat(), this.placeSelect.lng());
              }
            })
            .catch(err => {
              console.log(err)
              this.changePlace(this.placeSelect.lat(), this.placeSelect.lng());
            });
        }
    }
  }
</script>
<style scoped>
.v-select {
   color: #8f95a2 !important;
}
</style>